import React, { useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"

function UnrejectModal(props) {
   const [commentsBody, setCommentsBody] = useState("")
   
   const handleCloseUnrejectModal = () => {
      props.setShowUnrejectModal(false)
      setCommentsBody("")
   }

   const handleCommentsChange = (e) => {
      setCommentsBody(e.target.value)
   }

   function handleSubmit(e) {
      let data = props.moveData
      data = {
         ...data,
         comments: commentsBody,
      }
      handleCloseUnrejectModal()
      props.moveFromView(data)
      props.setShowUnrejectModal(false)
   }

   return (
      <>
         <Modal
            show={props.showUnrejectModal}
            onHide={handleCloseUnrejectModal}
            backdrop="static"
            keyboard={false}
         >
            <Modal.Header
               style={{ backgroundColor: "#007bff", color: "#FFFFFF" }}
               closeButton
            >
               <Modal.Title>Comments</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                     <Form.Label>Enter Comments</Form.Label>
                     <Form.Control
                        onChange={handleCommentsChange}
                        value={commentsBody}
                        as="textarea"
                        rows={3}
                        placeholder="Enter your comments here..."
                        autoFocus
                     />
                  </Form.Group>
               </Form>
            </Modal.Body>
            <Modal.Footer>
               <Button variant="secondary" onClick={handleCloseUnrejectModal}>
                  Close
               </Button>
               <Button
                  variant="primary"
                  onClick={handleSubmit}
                  disabled={commentsBody.length === 0}
               >
                  Submit
               </Button>
            </Modal.Footer>
         </Modal>
      </>
   )
}

export default UnrejectModal